import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Tooltip from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/Tooltip'
import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'

import Accrued from './Accrued'
import Advance from './Advance'
import Carryovers from './Carryovers'
import Incidence from './Incidence'

interface Props {
  accrued: number
  carryOver: number
  incidence: number
  selectedCycle: Cycle
  nextCycle: Cycle | null | undefined
  advance: number
}

const BalanceTooltip = ({
  accrued,
  carryOver,
  incidence,
  selectedCycle,
  nextCycle,
  advance,
}: Props) => {
  return (
    <Tooltip title={i18n.t('time_off.cycle_balance')}>
      <>
        <Accrued amount={accrued} selectedCycle={selectedCycle} />
        {carryOver > 0 && accrued > carryOver && <Carryovers amount={carryOver} />}
        {incidence > 0 && accrued > incidence && <Incidence allowanceIncidence={incidence} />}
        {advance < 0 && <Advance amount={advance} nextCycle={nextCycle} />}
      </>
    </Tooltip>
  )
}

export default observer(BalanceTooltip)
